import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Eye, Plus, Trash, DownloadSimple } from "@phosphor-icons/react";
import checkRoles from "@beeldit/user-and-access/auth/services/checkRoles";

const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
        {
          name: TableAction.EXPORT,
          label: 'export',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          variant: 'secondary',
          icon: <DownloadSimple size={20} />
        },
        {
          name: TableAction.CREATE,
          label: 'create',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          variant: 'primary',
          icon: <Plus size={20} />
        },
      ],
      rowActions: [
        {
          name: RowAction.DETAILS,
          label: 'edit',
          icon: <Eye size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('edit', element);
          }
        },
        {
          name: RowAction.DELETE,
          label: 'delete',
          icon: <Trash size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('delete', element);
          }
        }

      ],
      rowConfiguration: {
        class: (element: any) => {
          return null;
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          sortable: true,
        },
        {
          name: 'name->es',
          label: 'name',
          key: 'name.es',
          type: 'string',
          show: true,
          sortable: true,
        },
        {
          name: 'category',
          label: 'category',
          key: 'category.name.es',
          type: 'string',
          show: true,
          sortable: false,
        },
        {
          name: 'producer',
          label: 'producer',
          key: 'producer.user.name',
          type: 'string',
          show: (element: any, user: any) => {
              return checkRoles(user, ['admin']);
          },
          sortable: false,
        },
        {
          name: 'published',
          label: 'published',
          key: 'published',
          type: 'translation',
          translation_prefix: 'published',
          show: true,
          sortable: false,
        },
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const { indexFunction, initializeFunction, prepareRemoveFunction, detailsFunction, exportFunction } = functions;
    tableConfig.actions[0].action = () => exportFunction();
    tableConfig.actions[1].action = () => initializeFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => detailsFunction(id);
    tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
    return tableConfig;
}
export default getConfig;
